// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"e7f15a42","452":"417be1fb","484":"f16670ee","672":"a6868af8","803":"b9552bd1","864":"f5d9c77b","920":"523f5a41","968":"78e42b23","976":"24f6c8b8"}[chunkId] + ".chunk.js";
};